module.exports = __webpack_public_path__ + "static/img/sec4-cont01@w.26b863e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec4-cont01@w.jpg
// module id = KMiE
// module chunks = 0